const sitePersist = ['INSTITUTION', 'MEMBERSHIP'];
const instPersist = ['SITE_REGISTRATION', 'MEMBERSHIP'];
const memPersist = ['INSTITUTION', 'SITE_REGISTRATION'];

export const removeDuplicate = (persistObjData) => {
  if (persistObjData.length > 1) {
    const indexData = persistObjData.filter(
      (iData, indicies, self) => indicies === self.findIndex((obj) => obj.siteCtepId === iData.siteCtepId)
    );
    return indexData;
  }
  return persistObjData;
};

export const persistData = (currentValue, indexingRows) => {
  const persistedData = [];
  if (indexingRows != null && indexingRows.length > 0) {
    indexingRows.forEach((indexData) => {
      const persistObjData = {
        siteCtepId: indexData.siteCtepId,
        protocolNumber: currentValue === 'SITE_REGISTRATION' ? null : '',
        siteName: indexData.siteName,
        isSR: '',
        personCtepId: '',
        personName: '',
        objKeyValue: '',
        patientId: '',
        dmsPktMapId: '',
        pktId: indexData.pktId,
        objType: currentValue
      };
      persistedData.push(persistObjData);
    });
  }
  return removeDuplicate(persistedData);
};

export const setIndexingData = (previousValue, currentValue, clearIndexingGrid, indexingRows) => {
  switch (previousValue) {
    case 'SITE_REGISTRATION':
      if (sitePersist.includes(currentValue)) {
        return persistData(currentValue, indexingRows);
      }
      return clearIndexingGrid();
    case 'INSTITUTION':
      if (instPersist.includes(currentValue)) {
        return persistData(currentValue, indexingRows);
      }
      return clearIndexingGrid();
    case 'MEMBERSHIP':
      if (memPersist.includes(currentValue)) {
        return persistData(currentValue, indexingRows);
      }
      return clearIndexingGrid();
    case 'PERSON':
    case 'ENROLLMENT_TRANSFERS':
    case 'PAPER_CRFS_QUERIES':
      return clearIndexingGrid();
    default:
      return '';
  }
};
